import React from "react"
import { Link } from "react-router-dom";
import { Button } from "antd"
import { PlusOutlined } from "@ant-design/icons"
/* custom component */
import Header from "../../../../component/Header/Header"
import { PageContainer } from "../../../../component/Xcomponent"
import ContentRepoList from "../../../../component/ContentRepo/ContentRepoList/ContentRepoList";

const ContentRepoGeneralList = props => {

    return (
        <>
            <Header
                title="Content Repo General List"
                rightChildren={<Link to="/content-repo-general/add" ><Button type="primary" ><PlusOutlined />New</Button></Link>}
            />
            <PageContainer>
                <ContentRepoList refreshPageUrl={`content-repo-general/list`} pageUrl={`content-repo-general`} pageType="General" />
            </PageContainer>
        </>
    )
}

export default ContentRepoGeneralList